import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=64793e9e&scoped=true"
import script from "./MsgList.vue?vue&type=script&lang=js"
export * from "./MsgList.vue?vue&type=script&lang=js"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=64793e9e&prod&scoped=true&lang=less"
import style1 from "./MsgList.vue?vue&type=style&index=1&id=64793e9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64793e9e",
  null
  
)

export default component.exports